module.exports = __webpack_public_path__ + "images/share.jpg";


//////////////////
// WEBPACK FOOTER
// ./local_static/templates/quadro_de_medalhas/2018/assets/images/share.jpg
// module id = 334
// module chunks = 0